import { render, staticRenderFns } from "./ProfileDeleteComp.vue?vue&type=template&id=dcb1c6aa&scoped=true&"
import script from "./ProfileDeleteComp.vue?vue&type=script&lang=js&"
export * from "./ProfileDeleteComp.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDeleteComp.vue?vue&type=style&index=0&id=dcb1c6aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb1c6aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VTextField})
